import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { DELETE_MODAL } from "@/constants/campaignLifecycle";
import CampaignActionDialog from "./CampaignActionDialog";

interface DeleteCampaignModalProps {
  open: boolean;
  campaignName: string;
  /** A canceled campaign gets the "was canceled…" body + "Delete campaign"; a draft the plain one. */
  wasCanceled: boolean;
  /** The already-returned credit amount (formatted) for the canceled wallet clause; "" to omit it. */
  returnedCredits?: string;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirm deleting a Draft or a Canceled campaign. Both say "This can't be undone." — the 30-day
 * staff-only restore window is deliberately NOT surfaced (the client-facing promise is "it's gone").
 */
export default function DeleteCampaignModal({
  open,
  campaignName,
  wasCanceled,
  returnedCredits = "",
  onClose,
  onConfirm,
}: DeleteCampaignModalProps) {
  const copy = wasCanceled ? DELETE_MODAL.canceled : DELETE_MODAL.draft;
  const body = wasCanceled
    ? DELETE_MODAL.canceled.body(campaignName, returnedCredits)
    : DELETE_MODAL.draft.body(campaignName);

  return (
    <CampaignActionDialog
      open={open}
      title={copy.title}
      icon={DeleteOutlineIcon}
      body={body}
      primaryLabel={copy.confirm}
      secondaryLabel={copy.dismiss}
      danger
      onPrimary={onConfirm}
      onClose={onClose}
    />
  );
}
